import type { CoprincipalAccountSource } from "../store/schema/AccountSourceList";
import getCoprincipalAccountForAccountKey from "./getCoprincipalAccountForAccountKey";

export function getCoprincipalAccountForPersistenceId(persistenceId: string): CoprincipalAccountSource | undefined {
    // The persistenceId is just an alias for the account key -- see getCoprincipalAccountPersistenceId
    return getCoprincipalAccountForAccountKey(persistenceId);
}
